module.exports = __webpack_public_path__ + "static/media/proveedor.7b96913d.svg";